<template>
  <w-icon-wrapper icon-name='work-application-reject-icon'>
    <g
      id='_57_Antrag_ablehnen_Icon'
      data-name='57 Antrag ablehnen_Icon'
      transform='translate(-28)'
    >
      <path
        id='Pfad_55760'
        d='M47,14a1,1,0,0,0-1,1v7H30V4h8a1,1,0,0,0,0-2H28V24H48V15A1,1,0,0,0,47,14Z'
        data-name='Pfad 55760'
        fill='currentColor'
      />
      <path
        id='Pfad_55761'
        d='M33,8h5a1,1,0,0,0,0-2H33a1,1,0,0,0,0,2Z'
        data-name='Pfad 55761'
        fill='currentColor'
      />
      <path
        id='Pfad_55762'
        d='M40,10H33a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2Z'
        data-name='Pfad 55762'
        fill='currentColor'
      />
      <path
        id='Pfad_55763'
        d='M44,15a1,1,0,0,0-1-1H33a1,1,0,0,0,0,2H43A1,1,0,0,0,44,15Z'
        data-name='Pfad 55763'
        fill='currentColor'
      />
      <path
        id='Pfad_55764'
        d='M33,18a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z'
        data-name='Pfad 55764'
        fill='currentColor'
      />
      <path
        id='Pfad_55765'
        d='M46,0a6,6,0,1,0,6,6A6,6,0,0,0,46,0Zm0,10a4,4,0,0,1-4-4,3.957,3.957,0,0,1,.567-2.019l5.452,5.452A3.957,3.957,0,0,1,46,10Zm3.433-1.981L43.981,2.567A3.957,3.957,0,0,1,46,2a4,4,0,0,1,4,4A3.957,3.957,0,0,1,49.433,8.019Z'
        data-name='Pfad 55765'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconApplicationReject' };
</script>
